import { ReactNode } from "react";
import styled, { css } from "styled-components/native";
import { spacing_s } from "../../StyleHelpers";

const StyledNarrowMain = styled.View<any>`
	display: flex;
	padding: 6.5rem 8rem 1.5rem 8rem;
	justify-content: space-between;
	align-items: flex-start;
	flex: 1 0 0;
	align-self: stretch;

	${(props) =>
		props.isLanding &&
		css`
			padding: 6.5rem 19.625rem 1.5rem 8rem;
		`}
`;

const StyledNarrowContainer = styled.View`
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
	width: 100%;
	gap: ${spacing_s};
`;
interface Props {
	children: ReactNode;
	isLanding?: boolean;
}

const NarrowScreenContainer: React.FC<Props> = ({ children, isLanding }) => {
	return (
		// @ts-ignores
		<StyledNarrowMain isLanding={isLanding}>
			{/* @ts-ignore */}
			<StyledNarrowContainer>{children}</StyledNarrowContainer>
		</StyledNarrowMain>
	);
};

export default NarrowScreenContainer;
